import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { api } from '../api';

const PageWrapper = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #eef2ff 0%, #e0f2fe 100%);
  padding: 2rem 1rem;
`;

const Container = styled.div`
  max-width: 960px;
  margin: 0 auto;
`;

const PageTitle = styled.h1`
  font-size: 2.1rem;
  font-weight: 800;
  color: #111827;
  margin-bottom: 1.5rem;
`;

const PostList = styled.div`
  display: grid;
  gap: 1.25rem;
`;

const PostCard = styled(Link)`
  display: block;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #e5e7eb;
  padding: 1.5rem 1.75rem;
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.06);
  text-decoration: none;
  color: inherit;
  transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 18px 35px rgba(15, 23, 42, 0.12);
    border-color: #c7d2fe;
  }
`;

const PostMeta = styled.div`
  font-size: 0.8rem;
  color: #9ca3af;
  margin-bottom: 0.5rem;
`;

const PostTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 700;
  color: #111827;
  margin-bottom: 0.35rem;
`;

const PostExcerpt = styled.p`
  font-size: 0.95rem;
  color: #4b5563;
  margin-bottom: 0.65rem;
`;

const TagRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
`;

const Tag = styled.span`
  font-size: 0.75rem;
  padding: 0.15rem 0.6rem;
  border-radius: 999px;
  background: #eef2ff;
  color: #4f46e5;
  font-weight: 500;
`;

const Blog = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await api.get('/api/blog/posts');
        setPosts(data.posts || []);
      } catch {
        setPosts([]);
      }
    };
    load();
  }, []);

  return (
    <PageWrapper>
      <Container>
        <PageTitle>İşHazır Blog</PageTitle>

        <PostList>
          {posts.map((post) => (
            <PostCard
              id={post.slug || post.id}
              key={post.id}
              to={post.slug ? `/blog/${post.slug}` : `/blog/post/${post.id}`}
            >
              <PostMeta>
                {(post.published_at
                  ? new Date(post.published_at)
                  : new Date(post.created_at)
                ).toLocaleDateString('tr-TR')}{' '}
                • yaklaşık 5 dk okuma
              </PostMeta>
              <PostTitle>{post.title}</PostTitle>
              <PostExcerpt>{post.excerpt}</PostExcerpt>
              <TagRow>
                {(post.tags || []).map((tag) => (
                  <Tag key={tag}>{tag}</Tag>
                ))}
              </TagRow>
            </PostCard>
          ))}
        </PostList>
      </Container>
    </PageWrapper>
  );
};

export default Blog;
